<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo&&show_logo==1" :src="logo1" class="sidebar-logo1">
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
   computed: {
    ...mapGetters([
      'show_logo'
    ])
    },
  data() {
    return {
      title: '系统管理后台',
      logo: 'https://uniapp.wangshouxin.cn/hand-logo.png',
      logo1: require('../../../assets/logow.png') // require('../../../assets/long-log.png')
    }
  }
}
</script>

<style lang="scss" scoped>
$sideBarLogoHeight: 80px;
$sideBarLogoHeightShowText: 80px;

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  // position: relative;
  width: 100%;
  height: $sideBarLogoHeight;
  line-height: $sideBarLogoHeight;
  background: #12644E;
  text-align: center;
  // overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: auto; //32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-logo1 {
      width: auto; //190px;
      height: 65px;
      vertical-align: middle;
      margin-right: 6px;
      margin-left: 6px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: $sideBarLogoHeight;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.showText {
  .sidebar-logo-container {
    &.collapse {
      height: $sideBarLogoHeightShowText;
      line-height: $sideBarLogoHeightShowText;
    }
  }
}
</style>
